import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';
import denApi from '@/lib/api/denApi';
import type { GroupProposal } from '@/types/group-proposal';

type CreateGroupProposalArg = {
  groupName: string;
  userIds: string[];
};

const fetcher = async (
  _key: string,
  { arg }: { arg: CreateGroupProposalArg }
): Promise<GroupProposal> => {
  const { groupName, userIds } = arg;
  return await denApi.post<
    GroupProposal,
    { groupName: string; userIds: string[] }
  >(`admin/group/group-proposals`, {
    groupName,
    userIds,
  });
};

export function useCreateGroupProposal(
  swrOptions?: SWRMutationConfiguration<
    GroupProposal,
    Error,
    string,
    CreateGroupProposalArg
  >
) {
  const { trigger, isMutating, error } = useSWRMutation<
    GroupProposal,
    Error,
    string,
    CreateGroupProposalArg
  >('admin/group/group-proposals', fetcher, swrOptions);

  return { createProposal: trigger, isLoading: isMutating, error };
}
